import * as FIELD_NAME from 'constant/form-item-names'
import * as FIELD_LABEL from 'constant/form-labels'
import * as RULES from 'constant/form-rules'
import * as NUMBER from 'constant/number'
import React from 'react'
import { Form, Input } from 'antd'
import styles from '../styles.scss'

const TitleInput = () => {
  return (
    <>
      <span>{FIELD_LABEL.TITLE_INPUT}</span>
      <Form.Item
        name={FIELD_NAME.TITLE}
        rules={[RULES.REQUIRED, RULES.maxCharLength(NUMBER.ONE_HUNDRED)]}
      >
        <Input
          className={styles.form_input}
          placeholder={'Title'}
        />
      </Form.Item>
    </>
  )
}

export default TitleInput
